import {useEffect, useState} from 'react';
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from '@mui/material';
import {useAppSelector} from 'src/redux/hooks';
import {selectAccount} from 'src/redux/slice/accountSlice';
import {
  getHomePath,
  HOME_PATH_DASHBOARD,
  HOME_PATH_FRONT_DESK,
  setHomePath,
  subscribeHomePath,
} from 'src/utils/contextPreferences';

interface StartPagePreferenceProps {
  compact?: boolean;
}

export default function StartPagePreference({compact}: StartPagePreferenceProps) {
  const account = useAppSelector(selectAccount);
  const [, setTick] = useState(0);

  useEffect(() => subscribeHomePath(() => setTick(value => value + 1)), []);

  const value = getHomePath(account.userId, account.role?.name);

  const handleChange = (path: string) => {
    if (!account.userId) return;
    setHomePath(account.userId, path);
  };

  return (
    <FormControl>
      <FormLabel
        id="start-page-label"
        sx={{
          fontSize: compact ? '0.75rem' : '0.8125rem',
          fontWeight: 600,
          color: 'text.secondary',
          mb: compact ? 0.25 : 0.5,
        }}
      >
        Start Page
      </FormLabel>
      <RadioGroup
        aria-labelledby="start-page-label"
        value={value}
        onChange={event => handleChange(event.target.value)}
      >
        <FormControlLabel
          value={HOME_PATH_DASHBOARD}
          control={<Radio size="small" />}
          label="Dashboard"
          sx={{
            ml: compact ? -0.5 : 0,
            '& .MuiFormControlLabel-label': {fontSize: compact ? '0.875rem' : '0.9375rem'},
          }}
        />
        <FormControlLabel
          value={HOME_PATH_FRONT_DESK}
          control={<Radio size="small" />}
          label="Front Desk"
          sx={{
            ml: compact ? -0.5 : 0,
            '& .MuiFormControlLabel-label': {fontSize: compact ? '0.875rem' : '0.9375rem'},
          }}
        />
      </RadioGroup>
    </FormControl>
  );
}
